<template>
  <div style="padding: 20px 0 0 0">
    <el-form :inline="true" :model="formInline" label-position="left" @keydown.native.enter="onSubmit"
      class="demo-form-inline">
      <el-form-item label="入库单号:" @dblclick="dblclick('inboundCodeList')">
        <div @dblclick="dblclick('inboundCodeList')">
          <el-input maxlength='450' v-model="formInline.inboundCodeList" placeholder="双击批量搜索"
            @dblclick="dblclick('inboundCodeList')"></el-input>
        </div>
      </el-form-item>
      <template v-if="inboundType == 0">
        <el-form-item label="入库类型:">
          <el-select v-model="formInline.purchaseType" placeholder="全部">
            <el-option label="全部" :value="''"></el-option>
            <el-option label="成品" :value="0"></el-option>
            <el-option label="OEM" :value="1"></el-option>
            <el-option label="档口" :value="3"></el-option>
            <el-option label="马帮" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号:">

          <div @dblclick="dblclick('expressNoList')">
            <el-input maxlength='450' v-model="formInline.expressNoList" placeholder="双击批量搜索"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="采购单号:">
          <div @dblclick="dblclick('purchaseNoList')">
            <el-input maxlength='450' v-model="formInline.purchaseNoList" placeholder="双击批量搜索"></el-input>
          </div>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="创建人:">
          <el-input maxlength='450' v-model="formInline.creatorName" placeholder="请填入"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="创建时间:">
        <el-date-picker v-model="createDate" type="daterange" range-separator="至" start-placeholder="开始日期"
          @change="timeChange" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="批次号:">
        <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="请填入"></el-input>
      </el-form-item>
      <template v-if="inboundType == 0">
        <el-form-item label="业务类型:">
          <el-select v-model="formInline.systemSource" placeholder="全部">
            <el-option label="全部" :value="''"></el-option>
            <el-option label="B2B" :value="2"></el-option>
            <el-option label="D2C" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="标记">
        <el-select v-model="formInline.hasKeyCustomer" placeholder="全部">
          <el-option label="全部" :value='undefined'></el-option>
          <el-option label="重点客户" :value='1'></el-option>
          <el-option label="非重点客户" :value='0'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
    <BatchSearchDialog ref="batchSearchDialog" @search="batchSearch" />
  </div>
</template>

<script>
import moment from "moment"
import BatchSearchDialog from '@/components/BatchSearchDialog/index.vue'
export default {
  name: "InterForm",
  components: {
    BatchSearchDialog
  },
  props: {
    inboundType: {
      type: Number,
      required: true,
    },
    tableType: {
      type: String,
      default: () => '0'
    }
  },
  data() {
    return {
      formInline: {
      },
      createDate: []
    };
  },
  created() {
    this.$emit("querySubmit", this.formInline);
  },
  methods: {
    timeChange: function (val) {
      if (!val) {
        this.formInline.createStartTime = null;
        this.formInline.createEndTime = null;
        return;
      }
      this.formInline.createTimeStart = moment(val[0]).format("YYYY-MM-DD");
      this.formInline.createTimeEnd = moment(val[1]).format("YYYY-MM-DD");
    },
    onSubmit: function (e, type = "") {
      let params = {
        ...this.formInline,
        expressNoList: this.formInline.expressNoList && this.formInline.expressNoList.split(',') || [],
        inboundCodeList: this.formInline.inboundCodeList && this.formInline.inboundCodeList.split(',') || [],
        purchaseNoList: this.formInline.purchaseNoList && this.formInline.purchaseNoList.split(',') || [],
      }
      this.$emit("querySubmit", params);
    },
    restSubmit: function () {
      Object.keys(this.formInline).forEach(key => { console.log(key); this.formInline[key] = undefined })
      this.createDate = []
      this.onSubmit(undefined, "rest");
    },
    dblclick(key) {
      this.$refs.batchSearchDialog.open({ key })
    },
    batchSearch(params) {
      this.formInline = {
        ...this.formInline,
        ...params
      }
      console.log(params)
    }
  }
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
